export default __webpack_public_path__ + "static/media/project2-p1.5c0d0ca1.png";